import { PendingRequestsReducerState } from '../../../reducers/pendingRequestsReducer'

const requestIsPending = (
    pendingRequests: PendingRequestsReducerState,
    url: string | undefined,
    requiredParams?: string[], //specifies which query parameters MUST be present in the URL for it to be considered a match
): boolean => {
    if (!url) {
        return false
    }

    return Object.entries(pendingRequests).some(([pendingRequest, count]) => {
        if (count <= 0) {
            return false
        }

        const pendingUrl = new URL(pendingRequest)
        const patternUrl = new URL(url)
        if (!pendingUrl.pathname.startsWith(patternUrl.pathname)) {
            return false
        }

        if (requiredParams) {
            return requiredParams.every((param) => pendingUrl.searchParams.has(param))
        }

        return true
    })
}

export default requestIsPending
